function buildProductPath(options, pathname) {
  const paths = pathname.split('/');
  const handle = paths[paths.length - 1];
  const product_tokens = handle.split('?');
  let slug = options.slugs && options.slugs[options.locale] ? options.slugs[options.locale]: "-";
  product_tokens[0] = [slug, product_tokens[0], 'p'].join('-')
  const path = getMapping(options);
  return "/" + [path, product_tokens.join('?')].join("/");
}

function buildAccountPath(options, pathname, search) {
  const marketId = options.marketId
  if (pathname.includes("/account/activate/")) {
    const afterActivate = pathname.split("/account/activate/")[1]
    const [customerId, activationToken] = afterActivate.split("/")
    return `/api/internal-redirects/${marketId}/account/activate?customerId=${customerId}&activationToken=${activationToken}`
  } else if (pathname.includes("/account/reset/")) {
    const afterReset = pathname.split("/account/reset/")[1]
    const [customerId, resetToken] = afterReset.split("/")
    return `/api/internal-redirects/${marketId}/account/reset?customerId=${customerId}&resetToken=${resetToken}`
  } else {
    if (search.includes("invalid_token")) {
      return `/api/internal-redirects/${marketId}/account/invalid_token`
    } else {
      return `/api/internal-redirects/${marketId}/account/login`
    }
  }
}

function getMapping(options) {
  let value = options.mapping[options.locale];
  return value ? value: options.locale;
}

function redirectToDiscount(marketId, pathname) {
  const tokens = pathname.split("/discount/")
  const code = tokens[1];
  return `/api/internal-redirects/${marketId}/discount/${code}`
}

const redirect = (options, pathname, search) => {
  let to_url;
  let marketId = options.marketId
  const search_params = search ?? '';
  if (pathname.includes('/products/')) {
    to_url = buildProductPath(options, pathname);
  } else if (pathname.includes('/account/')) {
    to_url = buildAccountPath(options, pathname, search);
  } else if (pathname.includes('/cart')) {
    to_url = redirectToCart(marketId);
  } else if (pathname.includes("/discount/")) {
    to_url = redirectToDiscount(marketId, pathname);
  } else {
    //const path = getMapping(options)
    to_url = `/api/internal-redirects/${marketId}/home`;
  }
  return to_url + search_params;
}

const redirectToCart = (marketId) => `/api/internal-redirects/${marketId}/cart`;

// {"en"=>"epoca-wrap-dress", "it"=>"abito-a-portafoglio-epoca"}
const parseJsonMetafield = (str) => {
  try {
    let text = str.replace(new RegExp("=>", 'g'), ":");
    return JSON.parse(text)
  } catch (e) {
    return {};
  }
}

// export functions
if (typeof window != "undefined") {
  window.Xphub = {redirect, redirectToCart, parseJsonMetafield}
}
